import { render, staticRenderFns } from "./CoachTeamsDashboard.vue?vue&type=template&id=428cfa9b&"
import script from "./CoachTeamsDashboard.vue?vue&type=script&lang=ts&"
export * from "./CoachTeamsDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports